module.exports = __webpack_public_path__ + "static/media/99.a65274e7.jpg";